import { Injectable } from '@angular/core';
import { first, lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class FilesService {
  constructor(
    private authService: AuthService,
    private window: Window,
  ) {}

  async openWithId(id: string): Promise<void> {
    const url = await lastValueFrom(
      this.authService
        .addTenantIdParameterToUrl(`${environment.applicantApiEndpoint}/static-files/file/${id}`)
        .pipe(first()),
    );
    this.window.open(url, '_blank');
  }
}
